// extracted by mini-css-extract-plugin
module.exports = {"titleClass":"ShareIconModal_titleClass__NSLHU","alertMesage":"ShareIconModal_alertMesage__ckVGX"};